import { type IconName, LandingIcon } from "./LandingIcon";

const CAPABILITIES: readonly { icon: IconName; title: string; body: string }[] = [
  {
    icon: "layers",
    title: "Multi-finca",
    body: "Administrá varias propiedades desde una misma cuenta. Cada finca con su propio plan de cuentas y cierres contables independientes.",
  },
  {
    icon: "users",
    title: "Invitaciones y roles",
    body: "Sumá al capataz para registrar eventos del hato y a tu contador externo en modo lectura, cada uno con permisos diferenciados. Invitaciones por email, acceso inmediato.",
  },
  {
    icon: "history",
    title: "Audit trail completo",
    body: "Toda corrección queda registrada con timestamp y autor. El export sellado es inmutable; los ajustes se emiten en el período siguiente. El contador puede auditar el historial de cada evento.",
  },
];

export function LandingTeam() {
  return (
    <section className="relative z-10 border-white/[0.06] border-b bg-brand-dark">
      <div className="border-white/[0.06] border-b px-6 py-16 md:px-12">
        <h2 className="js-mask-reveal font-medium text-2xl text-white tracking-tight md:text-3xl">
          Escalá tu operación.
        </h2>
      </div>

      <div
        aria-hidden
        className="pointer-events-none absolute top-[calc(var(--spacing)*16+64px)] bottom-0 left-1/3 hidden w-px bg-white/[0.06] md:block"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute top-[calc(var(--spacing)*16+64px)] bottom-0 left-2/3 hidden w-px bg-white/[0.06] md:block"
      />

      <div className="relative z-10 grid grid-cols-1 md:grid-cols-3">
        {CAPABILITIES.map((c, i) => (
          <div
            key={c.title}
            className={`scroll-fade p-8 md:p-12 ${
              i < CAPABILITIES.length - 1 ? "border-white/[0.06] border-b md:border-b-0" : ""
            }`}
          >
            <div className="mb-6 flex h-10 w-10 items-center justify-center rounded-xl border border-white/[0.08] bg-brand-panel text-primary-500 shadow-[inset_0_1px_1px_rgba(255,255,255,0.05)]">
              <LandingIcon name={c.icon} size={20} />
            </div>
            <h3 className="mb-2 font-medium text-base text-white tracking-tight">{c.title}</h3>
            <p className="text-neutral-400 text-sm leading-relaxed">{c.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
